<template>
  <div class="insurancePlanPc">
    <img src="https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner4.png" width="100%" />
    <!-- 服务方案 -->
    <div class="container plan">
      <div class="internetTitle">
        结合互联网平台产品生态及服务场景 <br /> 为其定制医健保合作方案，赋能平台服务、获客及转化
      </div>
      <div class="planFlex">
        <h5>保险产品合作</h5>
        <div class="line"></div>
        <p>特定保险产品合作</p>
        <p>BBC健康服务商城</p>
        <img class="dot1" src="../../assets/image/dot.png" width="34px">
      </div>
      <div class="pant-content">
        <div class="circle">
          <div class="content">
            <p>携健康之力</p>
            <p>筑共赢未来</p>
          </div>
          <div class="left">
            <h5>流量运营方案</h5>
            <div class="line"></div>
            <p>特定人群服务包</p>
            <p>精准投放高效获客</p>
            <img class="dot2" src="../../assets/image/dot.png" width="34px">
          </div>
          <div class="right">
            <h5>用户运营方案</h5>
            <div class="line"></div>
            <p>平台专属健康权益</p>
            <p>会员健康福利设计</p>
            <img class="dot3" src="../../assets/image/dot.png" width="34px">
          </div>
          <img class="oval1" src="../../assets/image/oval1.png" width="546px">
          <img class="oval2" src="../../assets/image/oval2.png" width="742px">
        </div>
      </div>
    </div>
    <!-- 三大优势 -->
    <div class="madeAdvantage">
      <div class="container advantage">
        <div class="title">三大优势</div>
        <div class="advantageCon">
          <img class="bg" src="../../assets/image/123.png" />
          <div class="adList">
            <div class="adItem" v-for="(item,index) in adList" :key="index" @mouseover="addActive($event, index)"
              @mouseout="removeActive($event, index)">
              <img class="checkImg defaultImg" :src="item.iconUrl" />
              <img class="checkImg coverImg" :src="item.coverIcon" />
              <p class="adTitle">{{item.title}}</p>
              <p class="adDesc" v-html="item.desc"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务合作 -->
    <div class="backgroundGray">
      <div class="container cooperation-box">
        <p class="internetTitle">已合作服务50+互联网保险平台、互联网企业客户<br /> 其中业界头部平台合作多家</p>
        <div class="cooperation-box_img">
          <div class="left">
            <img src="../../assets/image/hezuo.png" width="510" height="432" />
          </div>
          <div class="right">
            <img src="../../assets/image/right_img1.png" width="592" height="334" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        adList: [{
            iconUrl: require('../../assets/image/net1.png'),
            coverIcon: require('../../assets/image/net11.png'),
            title: '专属定制',
            desc: '根据平台会员特性 <br />  定制专属服务/保险'
          },
          {
            iconUrl: require('../../assets/image/net2.png'),
            coverIcon: require('../../assets/image/net22.png'),
            title: '平台融合',
            desc: '将服务融入到平台产品体系与场景中 <br/>  用户无突兀感'
          },
          {
            iconUrl: require('../../assets/image/net3.png'),
            coverIcon: require('../../assets/image/net33.png'),
            title: '灵活对接',
            desc: '按需支持 <br/>  APP、小程序、API、SDK、H5对接'
          }
        ]
      }
    },
    methods: {
      addActive($event) {
        $event.currentTarget.className = 'adItem coverItem'
      },
      removeActive($event) {
        $event.currentTarget.className = 'adItem'
      }
    }
  }
</script>

<style scoped lang="less">
  .backgroundGray {
    background: #F7FAFF;
  }

  .insurancePlanPc {
    display: flex;
    flex-direction: column;
    .internetTitle{
       font-size: 40px;
      font-weight: 300;
      padding-bottom: 54px;
      line-height: 60px;
      text-align: center;
    }
    .plan {
      text-align: center;
      margin-top: 140px;
      color: #333333;
      height: 900px;

      h2 {
        font-size: 40px;
        font-weight: 300;
        margin-bottom: 30px;
      }

      .planFlex {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-items: center;
      }

      h5 {
        font-size: 24px;
        font-weight: 500;
        margin: 10px 0 0;
      }

      .line {
        width: 26px;
        height: 3px;
        background: #fd8246;
        border-radius: 2px;
        margin: 10px auto;
      }

      p {
        font-size: 16px;
        font-weight: 300;
        color: #666666;
        line-height: 15px;
        margin: 0 0 10px;
      }

      .dot1 {
        margin-top: 10px;
      }

      .dot2 {
        position: absolute;
        left: 211px;
        top: 22px;
      }

      .dot3 {
        position: absolute;
        left: 18px;
        top: 32px;
      }

      .circle {
        width: 320px;
        height: 320px;
        background: #fd8246;
        border-radius: 50%;
        text-align: center;
        margin: 0 auto;
        box-shadow: 0px 20px 30px 0px rgb(253 130 70 / 30%);
        margin-top: 189px;
        position: relative;

        img {
          z-index: -99;
        }

        .content {
          width: 320px;
          height: 320px;
          display: table-cell;
          vertical-align: middle;

          p {
            font-size: 30px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 46px;
          }
        }

        .left {
          position: absolute;
          left: -440px;
          top: 110px;
          z-index: -99;
        }

        .right {
          width: 300px;
          position: absolute;
          left: 490px;
          top: 120px;
        }

        .oval1 {
          position: absolute;
          bottom: -37%;
          left: -37%;
          animation: run1 12s linear infinite;
        }

        .oval2 {
          position: absolute;
          bottom: -67%;
          left: -67%;
          animation: run2 20s linear infinite;
        }
      }

    }
  }

  .madeAdvantage {
    margin-top: 330px;
    padding-top: 0%;
    background: #031323;

    .advantage {
      padding-bottom: 140px;
      .title {
        font-size: 40px;
        font-weight: 300;
        text-align: center;
        color: #ffffff;
        line-height: 56px;
        // margin-bottom: 125px;
        padding-top: 140px;
      }

      .advantageCon {
        position: relative;

        .bg {
          position: absolute;
          width: 916px;
          height: 223px;
          top: 0;
          left: 50%;
          margin-left: -459px;
        }

        .adList {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          font-size: 16px;
          color: #666666;
          font-weight: 300;
          padding-top: 121px;

          .adItem {
            width: 380px;
            height: 376px;
            background: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #666666;
            cursor: pointer;

            &:nth-child(2) {
              margin: 0 30px;
            }

            .checkImg {
              width: 41px;
              margin-bottom: 15px;
              border-radius: 22px;
              margin-top: 94px;
            }

            .defaultImg {
              display: inline-block;
            }

            .coverImg {
              display: none;
            }

            .adTitle {
              font-size: 24px;
              color: #333333;
              font-weight: 300;
              margin-bottom: 12px;
            }

            .adDesc {
              font-family: PingFangSC, PingFangSC-Light;
              text-align: center;
              font-size: 16px;
              line-height: 28px;
            }
          }

          .coverItem {
            background: #FD8246;
            color: #FFFFFF;

            .defaultImg {
              display: none;
            }

            .coverImg {
              display: inline-block;
            }

            .adTitle {
              color: #FFFFFF;
            }
          }
        }

      }
    }
  }

  .cooperation-box {
    color: #333333;
    padding: 140px 0;


    .cooperation-box_img {
      text-align: center;
      display: flex;
      // align-items: center;
      justify-content: space-between;
      background: #ffffff;
      width: 100%;
      margin: auto;
      height: 432px;

      // img {
      //   width: 100%;
      // }

      .left {
        // border-right: 1px solid rgba(151,151,151,0.1);
        // padding: 18px 65px 50px;
        width: 510px;
        img{
          width: 510px;
        }
      }

      .right {
        padding: 49px 0;
        width: 690px;
        img{
          width: 592px;
        }
      }

    }
  }

  @keyframes run1 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @keyframes run2 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(-360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/pc/internetPc.vue